import Marquee from "react-fast-marquee";
import { useLang } from "../../lib/i18n";

export const EditorialMarquee = ({ dark = false }) => {
  const { t } = useLang();
  return (
    <div className={`py-6 border-y ${dark ? "bg-[#0A192F] border-[#C9A03C]/20" : "bg-[#FAFAFA] border-black/5"}`} data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} autoFill>
        {t.marquee.map((txt) => (
          <span key={txt} className="flex items-center">
            <span className={`font-serif-lux text-2xl md:text-3xl tracking-wide ${dark ? "text-[#C9A03C]/70" : "text-[#0A192F]/50"}`}>{txt}</span>
            <span className="mx-8 text-[#C9A03C]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
